module.exports = __webpack_public_path__ + "img/1535431934.b27dc29c.jpg";